import Swiper, { Navigation, Thumbs, Scrollbar } from 'swiper';
import 'swiper/css';

const selectors = {
  carouselWrapper: '[data-product-gallery-image-carousel]',
  thumbnailWrapper: '[data-product-gallery-thumbnail-carousel]',
};

class ProductGallery extends HTMLElement {
  constructor() {
    super();

    this.carouselWrapper = document.querySelector(selectors.carouselWrapper);

    this.init();
  }

  init() {
    this.initCarousels();
  }

  initCarousels() {
    this.thumbnailCarousel = new Swiper(selectors.thumbnailWrapper, {
      direction: 'vertical',
      slidesPerView: 6,
      slideToClickedSlide: true,
      spaceBetween: 20,
      on: {
        init: () => {
          document
            .querySelector(selectors.thumbnailWrapper)
            .classList.remove('invisible', 'lg:w-10', 'lg:h-80');
        },
      },
    });

    const $next = this.carouselWrapper.parentNode.querySelector(
      '.swiper-button-next'
    );
    const $prev = this.carouselWrapper.parentNode.querySelector(
      '.swiper-button-prev'
    );
    const $scrollbar =
      this.carouselWrapper.parentNode.querySelector('.slider-scrollbar');

    this.galleryCarousel = new Swiper(selectors.carouselWrapper, {
      modules: [Navigation, Thumbs, Scrollbar],
      navigation: {
        nextEl: $next,
        prevEl: $prev,
      },
      scrollbar: {
        el: $scrollbar,
        draggable: true,
        enabled: true,
        snapOnRelease: false,
        dragSize: 100,
      },
      thumbs: {
        swiper: this.thumbnailCarousel,
      },
      on: {
        slideChange: swiper => {
          const slide =
            swiper.el.querySelectorAll('.swiper-slide')[swiper.previousIndex];
          const iframe = slide.querySelector('iframe');

          // No need for the API controller, here. Just reset the iframe's src
          // when changing to a different slide from a video.
          if (iframe) {
            iframe.setAttribute('src', iframe.getAttribute('src'));
          }
        },
      },
      breakpoints: {
        1024: {
          direction: 'vertical',
          scrollbar: {
            enabled: false,
          },
        },
      },
    });
  }
}

customElements.define('product-gallery', ProductGallery);
